import React from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import About from './About';
import Programs from './Programs';
import CoachingCenter from './CoachingCenter';
import Features from './Features';
import Testimonials from './Testimonials';
import EnrollForm from './EnrollForm';
import Footer from './Footer';

const HomePage = () => {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Programs />
      <CoachingCenter />
      <Features />
      <Testimonials />
      <EnrollForm />
      <Footer />
    </>
  );
};

export default HomePage;
